import { AES, enc } from 'crypto-js';

export function encrypt(data: string) {
  if (data) {
    const encryptedData = AES.encrypt(data, 'this!s@VerySecretKey').toString();
    return encryptedData;
  }
}

export function decrypt(encryptedData: string) {
  if (encryptedData) {
    const decryptedData = AES.decrypt(encryptedData, 'this!s@VerySecretKey').toString(enc.Utf8);

    return decryptedData;
  }
}
